import React, { useCallback } from 'react';
import pick from 'lodash/pick';

import { USE_WORK_EMAIL_MESSAGE } from 'Shared/utils/formValidations';

import ContentWrapper from '../Wrappers/ContentWrapper/ContentWrapper';
import { roleOptions } from '../../constants';
import FormFields from './FormFields/FormFields';
import SocialProof from './SocialProof/SocialProof';

type Props = {
  profile: {
    usingWP: Array<string>;
    role: string;
    fullName: string;
    avatar: object;
  };
  advanceOnboardingState: Function;
};

const ProfileWhiteList = Object.freeze(['fullName', 'email', 'role']);

function Profile({ profile, advanceOnboardingState }: Props) {
  const handleNextStep = useCallback(
    values => {
      const newProfile = values.profile;
      return advanceOnboardingState({
        profile: pick(newProfile, ProfileWhiteList),
      });
    },
    [advanceOnboardingState]
  );

  const errorsDisableSubmit = useCallback(errors => {
    if (Object.keys(errors?.profile || {}).some(e => e !== 'email')) return true;
    if (errors?.profile?.email) {
      if (errors?.profile?.email === USE_WORK_EMAIL_MESSAGE) return false;
      return true;
    }
    return false;
  }, []);

  return (
    <>
      <ContentWrapper
        initialValues={{
          profile: {
            ...profile,
            role:
              roleOptions.find(({ value }) => value === profile.role)?.value ||
              roleOptions.find(({ value }) => value === 'manager')?.value,
          },
        }}
        title="Get Started"
        errorsDisableSubmit={errorsDisableSubmit}
        description="Tell us a bit about yourself so we can personalize your experience"
        onNextStep={handleNextStep}
      >
        <FormFields />
      </ContentWrapper>
      <SocialProof />
    </>
  );
}

export default Profile;
